import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult, useMutation, UseMutationResult } from '@tanstack/react-query'

export const useGetMe = (): UseQueryResult<UserResponseType> => {
  const { getMe } = useVendorsApiClient()
  return useQuery<UserResponseType>({
    queryKey: ['me'],
    queryFn: () => getMe(),
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity
  })
}

export const useUpdateUserDetails = (): UseMutationResult<void, unknown, UpdateUserDetailsRequestType, unknown> => {
  const { updateUserDetails } = useVendorsApiClient()

  return useMutation({
    mutationFn: (payload: UpdateUserDetailsRequestType) => updateUserDetails(payload)
  })
}
